/* esm.sh - @smithy/util-hex-encoding@4.3.3 */
import{fromHex as r,toHex as x}from"@smithy/core/serde";export{r as fromHex,x as toHex};
//# sourceMappingURL=util-hex-encoding.mjs.map